var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIsoRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "12.165 1.176 11.224 4.52 15.709 9.366 12.165 1.176",
    opacity: 0.33,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0522,1.2313,11,0H10L0,2V13l5,3H6l10-2V8.0429ZM12.223,1.9l.0391.0235L15,8.25,11.5,4.4689Zm-.8887-.5333L11,2.5542V1.1662ZM5,14.8338,1.49,12.7275,5,12.015Zm0-3.829-4,.8039V3.3711L5,5.5625ZM1.6862,2.6826,10,1.02V4.188L6,5ZM10,5.1961V10l-4,.8038V6ZM6,14.98V11.812L10,11l4.3217,2.3159Zm5-4.5427V5.4007l4,4.3214v2.9016Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIsoRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iso-right.21c0bf6f416843a5015ca6db95e561bd.svg";